<template>
  <div v-if="showTaxes">
    <div class="row">
      <div class="col-xs-12">
        <p>
          <a
            class="make-link"
            href="https://movemais.com/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais"
            v-smooth-scroll
          >
            *Conheça nossos valores de recarga.
          </a>
        </p>
      </div>
    </div>
    <div class="row" id="rechargeB2B">
      <div class="col-xs-12 margin-b10">
        <h3 class="bold upper">Recargas</h3>
        <p>As recargas estão sujeitas a taxas, verifique os valores:</p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <!-- id: 1,
              rechargeValue: "250*",
              rechargeTax: "25,00",
              additionalInformation: "*Apenas plano Estradeiro",
              colorClass: "red",
              classLastChildInLine: false, -->
        <div v-for="taxas in typeSelected.values" :key="taxas.id">
          <div
            style="margin-bottom: 2rem"
            :class="
              taxas.classLastChildInLine
                ? 'box-recharge-' + taxas.classLastChildInLine
                : 'box-recharge'
            "
          >
            <div :class="'recharge-' + taxas.colorClass">
              <div :class="'recharge-value-' + taxas.colorClass">R$</div>
              <div :class="'recharge-label-' + taxas.colorClass">
                {{ taxas.rechargeValue }}
              </div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>{{ taxas.rechargeTax | cents }}</p>
              </div>
            </div>
            <small v-if="taxas.additionalInformation">{{
              taxas.additionalInformation
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cents } from "../filters/number";
import Financial from "../services/financial";

export default {
  props: ["showTaxes"],
  data() {
    return {
      typeSelected: {},
      taxas: [
        //  {
        //   type: "exemplo", // nome que será passado no componente quando chamado na sua página.
        //   values: [
        //     {
        //       id: 1,
        //       rechargeValue: "250*", // valor da recarga.
        //       rechargeTax: "25,00", // valor da taxa.
        //       additionalInformation: "*Apenas plano Estradeiro", // caso tenha alguma informação que fique a baixo do card.
        //       colorClass: "red", // cor do card.
        //       classLastChildInLine: false, // caso seja o último card da linha, no caso o quinto essa propriedade deve ser 'last'.
        //     }
        //   ]
        //  },
        {
          type: "pj",
          values: [],
        },
        {
          type: "pf",
          values: [],
        },
      ],
    };
  },
  mounted() {
    this.getNovasTaxas();

    this.showTaxes == "pf" ? (this.taxas.pf = true) : (this.taxas.pj = true);

    this.typeSelected = this.taxas.find(
      (taxas) => taxas.type == this.showTaxes
    );
  },
  methods: {
    async getNovasTaxas() {
      const { data } = await Financial.getNovasTaxas();
      const arrayPjFiltro = data.consultado.filter((ele) => ele[0] == "PJ");
      const arrayPfFiltro = data.consultado.filter((ele) => ele[0] == "PF");

      let corPJ = "";
      let corPF = "";
      let lastLine = false;

      // Sequencia de cor red, yellow, green, blue e purple
      let cor = {
        corPJ() {
          if (corPJ == "") {
            corPJ = "red";
            lastLine = false;
            return "red";
          } else if (corPJ == "red") {
            corPJ = "yellow";
            lastLine = false;
            return "yellow";
          } else if (corPJ == "yellow") {
            corPJ = "green";
            lastLine = false;
            return "green";
          } else if (corPJ == "green") {
            corPJ = "blue";
            lastLine = false;
            return "blue";
          } else if (corPJ == "blue") {
            corPJ = "purple";
            lastLine = "last";
            return "purple";
          } else if (corPJ == "purple") {
            corPJ = "red";
            lastLine = false;
            return "red";
          }
        },
        corPF() {
          if (corPF == "") {
            corPF = "red";
            lastLine = false;
            return "red";
          } else if (corPF == "red") {
            corPF = "yellow";
            lastLine = false;
            return "yellow";
          } else if (corPF == "yellow") {
            corPF = "green";
            lastLine = false;
            return "green";
          } else if (corPF == "green") {
            corPF = "blue";
            lastLine = false;
            return "blue";
          } else if (corPF == "blue") {
            corPF = "purple";
            lastLine = "last";
            return "purple";
          } else if (corPF == "purple") {
            corPF = "red";
            lastLine = false;
            return "red";
          }
        },
      };

      arrayPfFiltro.forEach((ele, index) => {
        let objPf = {
          id: index + 1,
          rechargeValue: ele[4] == 99 ? `${ele[5] / 100}+` : ele[5] / 100,
          rechargeTax: ele[4] == 99 ? `${ele[6]}%` : ele[6],
          additionalInformation: false,
          colorClass: cor.corPF(),
          classLastChildInLine: lastLine,
        };

        this.taxas[1].values.push(objPf);
      });

      arrayPjFiltro.forEach((ele, index) => {
        let ObjPj = {
          id: index + 1,
          rechargeValue:
            ele[4] == 99
              ? `${ele[5] / 100}+`
              : index == 0
              ? `${ele[5] / 100}*`
              : ele[5] / 100,
          rechargeTax: ele[4] == 99 ? `${ele[6]}%` : ele[6],
          additionalInformation:
            index === 0 ? "*Apenas plano Estradeiro" : false,
          colorClass: cor.corPJ(),
          classLastChildInLine: lastLine,
        };
        this.taxas[0].values.push(ObjPj);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.border-radius-top {
  -webkit-border-radius: 10px 10px 0 0;
  -moz-border-radius: 10px 10px 0 0;
  -ms-border-radius: 10px 10px 0 0;
  -o-border-radius: 10px 10px 0 0;
  border-radius: 10px 10px 0 0;
}
.recharge-info {
  margin-top: 5px;
}

.box-rntrc-bond {
  border-radius: 10px;
  min-height: 225px;
  padding: 10px;
  width: 100%;
}
.txt-rntrc-bond {
  float: left;
  font-size: 1.2em;
  margin-top: 25px;
  text-align: center;
  width: 72%;
}
.txt-rntrc-bond h4 {
  font-size: 1.2em;
}
.btn-rntrc-bond {
  margin: 30px 0 15px;
}
.img-tag-rntrc {
  float: right;
  width: 28%;
}

.box-recharge {
  float: left;
  height: 150px;
  margin: 0 30px 25px 0;
  width: calc(20.25% - 30px);
}
.box-recharge-last {
  float: left;
  height: 150px;
  margin: 0 0 25px 0;
  width: 19%;
}
.recharge-red {
  -webkit-border-radius: 10px;
  background: #e74213;
  border-radius: 10px;
  color: white;
  width: 100%;
}
.recharge-label-red {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #e74213;
  border-radius: 10px 10px 0 0;
  color: #e74213;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-red {
  -webkit-border-radius: 10px 0 10px 0;
  background: #e74213;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-yellow {
  -webkit-border-radius: 10px;
  background: #eda801;
  border-radius: 10px;
  color: white;
  width: 100%;
}
.recharge-label-yellow {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #eda801;
  border-radius: 10px 10px 0 0;
  color: #eda801;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-yellow {
  -webkit-border-radius: 10px 0 10px 0;
  background: #eda801;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}

.recharge-green {
  -webkit-border-radius: 10px;
  background: #569109;
  border-radius: 10px;
  color: white;
  width: 100%;
}
.recharge-label-green {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #569109;
  border-radius: 10px 10px 0 0;
  color: #569109;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-green {
  -webkit-border-radius: 10px 0 10px 0;
  background: #569109;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-blue {
  -webkit-border-radius: 10px;
  background: #0074c8;
  border-radius: 10px;
  color: white;
  width: 100%;
}
.recharge-label-blue {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #0074c8;
  border-radius: 10px 10px 0 0;
  color: #0074c8;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-blue {
  -webkit-border-radius: 10px 0 10px 0;
  background: #0074c8;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-purple {
  -webkit-border-radius: 10px;
  background: #503066;
  border-radius: 10px;
  color: white;
  width: 100%;
}
.recharge-label-purple {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #503066;
  border-radius: 10px 10px 0 0;
  color: #503066;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-purple {
  -webkit-border-radius: 10px 0 10px 0;
  background: #503066;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-tax-label {
  color: white;
  padding: 10px 5px;
  text-align: center;
  width: 100%;
}
@media screen and (max-width: 320px) {
  .box-recharge {
    height: 170px;
  }
  .recharge-label-red,
  .recharge-label-yellow,
  .recharge-label-green,
  .recharge-label-blue,
  .recharge-label-purple {
    font-size: 2.6em;
    padding: 25px 10px;
  }
}
@media screen and (min-width: 321px) and (max-width: 619px) {
  .box-recharge {
    height: 180px;
  }
  .recharge-label-red,
  .recharge-label-yellow,
  .recharge-label-green,
  .recharge-label-blue,
  .recharge-label-purple {
    font-size: 2.4em;
    padding: 28px 10px;
  }
}
@media screen and (max-width: 500px) {
  .box-recharge,
  .box-recharge-last {
    float: left;
    font-size: 0.8em;
    margin: 0 10px;
    width: calc(50% - 20px);
  }
}

@media screen and (min-width: 620px) and (max-width: 768px) {
  .recharge-label-red,
  .recharge-label-yellow,
  .recharge-label-green,
  .recharge-label-blue,
  .recharge-label-purple {
    font-size: 3em;
    padding: 25px 20px;
    min-height: 95px;
  }
}

@media screen and (min-width: 501px) and (max-width: 990px) {
  .box-recharge,
  .box-recharge-last {
    float: left;
    margin: 0 15px 30px;
    width: calc(33% - 30px);
  }
  .recharge-tax-label {
    font-size: 0.95em;
  }
}

@media screen and (max-width: 991px) {
  .recharge-info {
    margin-bottom: 20px;
  }
  .recharge-tax-label p {
    margin-bottom: 2px;
  }
  .box-rntrc-bond {
    padding: 15px;
    min-height: auto;
  }
  .txt-rntrc-bond {
    font-size: 1em;
    margin-top: 0;
    width: 100%;
  }
  .btn-rntrc-bond {
    margin: 15px 0;
  }
  .img-tag-rntrc {
    display: none;
  }
}
@media screen and (min-width: 991px) and (max-width: 1199px) {
  .recharge-label-red,
  .recharge-label-yellow,
  .recharge-label-green,
  .recharge-label-blue,
  .recharge-label-purple {
    font-size: 2.3em;
    padding: 10px 25px;
  }
  .box-rntrc-bond {
    min-height: 190px;
  }
  .txt-rntrc-bond {
    font-size: 1em;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// card-taxes.vue?66b02633